<div class="search">
    <button class="btn btn-info btn-purchasenewpack" (click)="create()">Create Printer</button>
    <div class="search-input-icon">
        <div class="search-input"><i class="flaticon-search"></i></div>
        <input type='text' [placeholder]='"Search Printers..."' (keyup)='search()' [(ngModel)]="searchText" class="searchtext"/>
    </div>
</div>

<br>

<ngx-spinner
    bdColor="rgba(75, 55, 100, 0.5)"
    size="large"
    color="#fff"
    type="line-scale-pulse-out">
        <span class="chevron left"></span>
        <span class="chevron right"></span>
  </ngx-spinner>

<ngx-datatable 
    #packageTable 
    class='material striped datatable' 
    [rows]='display' 
    [columnMode]='"force"'
    [headerHeight]='40' 
    [sorts]="[{prop: 'id', dir: 'desc'}]"
    [footerHeight]='20' 
    [scrollbarH]="true" 
    [scrollbarV]="true" 
    [rowHeight]="40"
    [reorderable]="true">

    <ngx-datatable-column prop="name" [sortable]="true">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()">
                Printer Name
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            {{row.name}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="name" [sortable]="true">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()">
                Assigned Event
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            {{row.cue5050?.event.name || ''}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="actions" [sortable]="false">
        <ng-template let-column="column" ngx-datatable-header-template class="actions-row">
            <span></span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            <button class="btn btn-success btn-icon" (click)="edit(row.barrelPrinterId)"><i class="flaticon-edit-1"></i></button>
            <button class="btn btn-danger btn-icon" (click)="delete(row.barrelPrinterId)"><i class="flaticon-cancel"></i></button>
        </ng-template>
    </ngx-datatable-column>
</ngx-datatable>